(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Phones and tablets get content instantly — scroll reveals are desktop-only.
  var phone = window.matchMedia('(max-width: 989px)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    document.documentElement.classList.add('wilin-js');
    if (!reduce && !phone) document.documentElement.classList.add('wilin-motion');

    // Mark major sections for reveal if not already tagged
    var autoSelectors = [
      '.wilin-catalog-cta',
      '.wilin-sellers',
      '.wilin-story',
      '.wilin-faq',
      '.wilin-benefits',
      '.wilin-tabs',
      '.wilin-collection__header',
      '.wilin-collection__grid',
      '.wilin-footer__top',
      '.wilin-pdp__gallery',
      '.wilin-related',
      '.wilin-hero__content',
      '.wilin-announce'
    ];
    autoSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.hasAttribute('data-wilin-reveal')) el.setAttribute('data-wilin-reveal', '');
      });
    });

    // Stagger product cards
    document.querySelectorAll('.wilin-collection__grid, .wilin-sellers__grid, .wilin-related .wilin-sellers__grid, .wilin-pack-modal__grid').forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (child, i) {
        child.style.setProperty('--wilin-stagger', String(Math.min(i, 12)));
        child.setAttribute('data-wilin-reveal', 'card');
      });
    });

    if (reduce || phone) {
      document.querySelectorAll('[data-wilin-reveal]').forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    // Scroll reveal
    // threshold MUST stay 0: a ratio threshold is measured against the element's own
    // height, so anything taller than (viewport / threshold) can never satisfy it and
    // would stay opacity:0 forever. Long product descriptions hit exactly that.
    var revealEls = document.querySelectorAll('[data-wilin-reveal]');
    function reveal(el) { el.classList.add('is-in'); }
    if (revealEls.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          io.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });

      // Failsafe: never let content stay invisible. Anything still hidden but already
      // within (or above) the viewport gets revealed on load and on scroll.
      var sweep = function () {
        var left = 0;
        revealEls.forEach(function (el) {
          if (el.classList.contains('is-in')) return;
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) { reveal(el); io.unobserve(el); }
          else left++;
        });
        if (!left) window.removeEventListener('scroll', sweep);
      };
      window.addEventListener('scroll', sweep, { passive: true });
      window.addEventListener('load', sweep);
      setTimeout(sweep, 1200);
    } else {
      revealEls.forEach(reveal);
    }

    // Hero: gentle entrance only (no parallax — keeps quote framed)
    var hero = document.querySelector('.wilin-hero');
    if (hero) {
      requestAnimationFrame(function () {
        hero.classList.add('is-ready');
      });
    }
    var para = document.querySelector('[data-wilin-parallax]');
    if (para) {
      para.style.transform = 'none';
      para.removeAttribute('data-wilin-parallax');
    }

    // Soft magnetic buttons (subtle) — mouse only; on touch this fires during
    // scroll and makes buttons wobble under the finger.
    if (finePointer) document.querySelectorAll('.wilin-btn, .wilin-pdp__atc').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.05) + 'px,' + (y * 0.06) + 'px)';
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.transform = '';
      });
    });

    // PDP main product image crossfade helper
    var mainImg = document.getElementById('WilinPdpMainImg');
    if (mainImg) {
      var imgObserver = new MutationObserver(function () {
        mainImg.classList.remove('is-swapping');
        // force reflow
        void mainImg.offsetWidth;
        mainImg.classList.add('is-swapping');
      });
      imgObserver.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }

    // Pack tier press feedback
    document.querySelectorAll('[data-pack-qty]').forEach(function (tier) {
      tier.addEventListener('click', function () {
        tier.classList.add('is-pulse');
        setTimeout(function () { tier.classList.remove('is-pulse'); }, 320);
      });
    });
  });
})();
